/* import external modules */
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'


import messages from '../../../constants/messages'

import {
  InputRange,
  Label,
  WrapperActions,
  WrapperButton,
  WrapperImgCrop,
  WrapperZoom,
} from './styles'
import Cropper from 'react-easy-crop'
import theme from '../../../constants/themeConstants' 
import cname from '../../../constants/classNameData'
import { getCroppedImg } from '../../../herpers/cropperHelper'
import Button from '../Button'
import ButtonPrimary from '../ButtonPrimaryMd'
import Modal from '../Modal'
import P from '../P'

const ModalCropper = ({
  isOpen,
  onClose,
  image,
  width,
  height,
  aspectRatio,
  imageLoaded,
  isObt
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedArea, setCroppedArea] = useState()
  const dispatch = useDispatch();

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels)
  }, [])

  const handleSetZoom = (value) => {
    setZoom(value.target.value)
  }
  const handleEndCrop = async () => {
    if (!croppedArea) {
      
      console.error("Cropped area not set.");
      onClose(); 
      return;
    }
    const croppedImage = await getCroppedImg(
      { width, height },
      image,
      croppedArea
    )
    if(croppedImage === 'error'){
      console.log('error')
    }
    imageLoaded(croppedImage) 
    onClose(); 
  }

  return (
    <Modal open={isOpen} onClose={onClose} width={"540px"} isObt={isObt} className="modal-crop">
      <P
        font="18px/26px 'DMSans-Medium'"
        fontSm="16px/24px'DMSans-Medium'"
        color={theme.colors.gray_1}
        align="left"
        mb="20px">
        Ajustar imagen
      </P>
    
      <WrapperImgCrop>
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </WrapperImgCrop>
      <WrapperActions>
        <WrapperZoom>
          <Label>Zoom</Label>
          <InputRange
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            onChange={handleSetZoom}
            type="range"
          />
        </WrapperZoom>
        <WrapperButton>
          <Button
            title="Cancelar"
            className={cname.cancel_adjustment_image}
            name="cancelar"
            width="100px"
            textAlign="center"
            color="#006CA5"
            font="14px/18px 'DMSans-Regular'"
            border="none"
            backgroundColor="#ffffff"
            float="left" 
            onClick={onClose}
          />
          <ButtonPrimary
            text="Aceptar"
            className={cname.agree_adjustment_image}
            width="100px"
            onClick={handleEndCrop}
            name="aceptar"
          />
        </WrapperButton>
      </WrapperActions>
    </Modal>
  )
}

ModalCropper.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  image: PropTypes.string, 
  width: PropTypes.number, 
  height: PropTypes.number, 
  aspectRatio: PropTypes.number,
  imageLoaded: PropTypes.func.isRequired, 
  isObt: PropTypes.bool
}

ModalCropper.defaultProps = {
  isObt: false,
};

export default ModalCropper 